export const vatConverter = (price: number): string => {
    return parsePriceAsString(removeVat(price));
};

export const removeVat = (price: number): number => price * 0.8;

export const parsePriceAsString = (price: number): string => {
    return price.toLocaleString("da-DK", {
        style: "currency",
        currency: "DKK"
    });
};

export const roundToTwoDecimals = (price: number) => {
    return Math.round(price * 100) / 100;
};